import type { TextareaHTMLAttributes } from 'react';

import { cx } from '../lib/cx.ts';
import { useFieldState } from './Field.tsx';
import { controlClasses } from './TextInput.tsx';

type TextAreaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'> & {
  className?: string;
};

export function TextArea({ rows = 3, className, ...rest }: TextAreaProps) {
  const field = useFieldState();

  return (
    <textarea
      id={field?.inputId}
      rows={rows}
      aria-describedby={field?.describedBy}
      aria-invalid={field?.invalid || undefined}
      className={cx(controlClasses, 'resize-y', className)}
      {...rest}
    />
  );
}
